import React from 'react';

const NotFound = () => {
    return (
        <div className='text-danger text-center'>
            <h3>Error</h3>
            <h3>Page Not Found</h3>
        </div>
    );
};

export default NotFound;